import React, { useState, useEffect } from 'react';
import sanctumApi from '../services/api';
import './DashboardHome.css';

const DashboardHome = () => {
  const [stats, setStats] = useState({
    admins: 0,
    waitlist: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    setLoading(true);
    try {
      const [adminsData, waitlistData] = await Promise.all([
        sanctumApi.getAdmins(),
        sanctumApi.getWaitlist(1, 1) // Just to get total count
      ]);
      
      setStats({
        admins: adminsData.length,
        waitlist: waitlistData.total
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dashboard-home">
      <div className="stats-grid">
        <div className="stat-card">
          <h3>Total Admins</h3>
          <p className="stat-number">
            {loading ? '...' : stats.admins}
          </p>
        </div>
        <div className="stat-card">
          <h3>Waitlist Users</h3>
          <p className="stat-number">
            {loading ? '...' : stats.waitlist}
          </p>
        </div>
      </div>
      <div className="quick-actions">
        <h2>Quick Actions</h2>
        <ul>
          <li>Manage administrator accounts</li>
          <li>View and export waitlist users</li>
          <li>More features coming soon...</li>
        </ul>
      </div>
    </div>
  );
};

export default DashboardHome;